export enum GDSettingsPanelEvents {
  APPLY_BUTTON_CLICKED = 'applyButtonClicked',
  RESET_WIDGETS_BUTTON_CLICKED = 'resetWidgetsButtonClicked',
}
